var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowInterest(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "16px",
    viewBox: "0 0 19 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icArrowInterest") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.1621005,7.32198052 C18.1781049,7.57124352 18.0908571,7.82589615 17.9003571,8.0163961 L11.5363961,14.3803571 C11.1849242,14.731829 10.6150758,14.731829 10.2636039,14.3803571 C9.91213203,14.0288853 9.91213203,13.4590368 10.2636039,13.1075649 L16.0491883,7.32198052 L10.2636039,1.5363961 C9.91213203,1.18492424 9.91213203,0.61507576 10.2636039,0.263603897 C10.6150758,-0.0878679656 11.1849242,-0.0878679656 11.5363961,0.263603897 L17.9003571,6.62756493 C18.0908571,6.81806488 18.1781049,7.07271751 18.1621005,7.32198052 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NOTIFICATIONS",
    transform: "translate(-311.000000, -1575.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DateFinder-Interests",
    transform: "translate(-335.000000, 1434.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(346.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(6.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interests",
    transform: "translate(188.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(114.820000, 43.300000) scale(-1, 1) translate(-114.820000, -43.300000) translate(105.320000, 35.800000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icArrowInterest"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(14.081981, 7.321981) scale(-1, 1) translate(-14.081981, -7.321981) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16210049,7.32198052 C8.17810487,7.57124352 8.09085709,7.82589615 7.90035713,8.0163961 L1.5363961,14.3803571 C1.18492424,14.731829 0.61507576,14.731829 0.263603897,14.3803571 C-0.0878679656,14.0288853 -0.0878679656,13.4590368 0.263603897,13.1075649 L6.04918831,7.32198052 L0.263603897,1.5363961 C-0.0878679656,1.18492424 -0.0878679656,0.61507576 0.263603897,0.263603897 C0.61507576,-0.0878679656 1.18492424,-0.0878679656 1.5363961,0.263603897 L7.90035713,6.62756493 C8.09085709,6.81806488 8.17810487,7.07271751 8.16210049,7.32198052 Z",
    id: "Mask",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(4.081981, 7.321981) scale(-1, 1) translate(-4.081981, -7.321981) "
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowInterest);
export default __webpack_public_path__ + "static/media/icArrowInterest.6cd09f7c9e39fcd25efa85f11e6b4beb.svg";
export { ForwardRef as ReactComponent };